import React from 'react';
import { Share2, Link as LinkIcon, ShieldAlert, Cpu, Workflow, Terminal } from 'lucide-react';
import './SaaSDevelopment.css';

const APIIntegration = () => {
  return (
    <div className="saas-page">
      <section className="hero-section">
        <div className="hero-content">
          <div className="hero-copy">
            <span className="eyebrow">Digital Connectivity</span>
            <h1>Seamless API Integration & Ecosystems</h1>
            <p>
              Connect your tools, automate your workflows, and create a unified 
              software ecosystem with our expert API integration services.
            </p>
            <div className="hero-actions">
              <a className="button primary" href="#contact">Connect Systems</a>
              <a className="button secondary" href="#services">Our expertise</a>
            </div>
          </div>
          <div className="hero-panel">
            <div className="panel-card panel-glow">
              <Share2 className="icon" />
              <h3>Interconnected</h3>
              <p>Break down data silos and let your various software platforms talk to each other.</p>
            </div>
          </div>
        </div>
      </section>

      <section id="services" className="section">
        <div className="section-heading">
          <span className="eyebrow">Solutions</span>
          <h2>The glue that holds your tech together.</h2>
          <p>We handle complex integrations so you can focus on running your business, not managing data entry.</p>
        </div>

        <div className="capabilities-grid">
          <div className="capability-card">
            <div className="cap-icon"><LinkIcon size={24} /></div>
            <h3>Third-Party APIs</h3>
            <p>Integrating Stripe, Twilio, Google Maps, Salesforce, and thousands more.</p>
          </div>
          <div className="capability-card">
            <div className="cap-icon"><Terminal size={24} /></div>
            <h3>Custom API Dev</h3>
            <p>Building secure RESTful and GraphQL APIs tailored to your proprietary data.</p>
          </div>
          <div className="capability-card">
            <div className="cap-icon"><ShieldAlert size={24} /></div>
            <h3>Secure Auth</h3>
            <p>Implementing OAuth2, JWT, and SAML to keep your data transfers safe.</p>
          </div>
          <div className="capability-card">
            <div className="cap-icon"><Workflow size={24} /></div>
            <h3>Webhooks & Events</h3>
            <p>Automating actions based on real-time events across your software suite.</p>
          </div>
        </div>
      </section>

      <section className="section bg-glass">
        <div className="solutions-container">
          <div className="solution-row reverse">
            <div className="solution-copy">
              <h3>Enterprise Service Bus</h3>
              <p>
                For larger organizations, we implement message brokers and middleware 
                to manage traffic and ensure delivery between critical systems.
              </p>
              <ul className="feature-list">
                <li><Cpu size={18} /> Redis Cache Integration</li>
                <li><Cpu size={18} /> RabbitMQ / Kafka Streams</li>
                <li><Cpu size={18} /> Rate Limiting & Throttling</li>
              </ul>
            </div>
            <div className="solution-media">
               <div className="panel-card panel-gradient">
                <Workflow size={64} className="icon" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="metrics-grid">
        <div className="metric-item">
          <strong>100+</strong>
          <span>Integrations Available</span>
        </div>
        <div className="metric-item">
          <strong>&lt;50ms</strong>
          <span>Latency Target</span>
        </div>
        <div className="metric-item">
          <strong>99.99%</strong>
          <span>Uptime Reliability</span>
        </div>
        <div className="metric-item">
          <strong>256-bit</strong>
          <span>Encryption</span>
        </div>
      </div>

      <section className="cta-section">
        <div className="cta-content">
          <h2>Tired of manual data entry?</h2>
          <p>Let us automate your business by connecting your favorite software tools.</p>
          <a className="button primary" href="#contact">Consult an Expert</a>
        </div>
      </section>
    </div>
  );
};

export default APIIntegration;
